import LoadingButton from '@mui/lab/LoadingButton';
import { setNestedObjectValues, useFormikContext } from 'formik';

const getFirstErrorField = (errors: any, parentPath = ''): string => {
  if (!errors || typeof errors !== 'object') return '';

  for (const key of Object.keys(errors)) {
    const value = errors[key];
    const path = parentPath ? `${parentPath}.${key}` : key;
    if (typeof value === 'string') return path;
    const nestedPath = getFirstErrorField(value, path);
    if (nestedPath) return nestedPath;
  }
  return '';
};

const MFSubmitButton = ({
  label = 'Submit',
  variant = 'contained',
  fullWidth = true,
  loadingEnable = false,
  ...props
}: {
  label: string;
  variant?: 'contained' | 'text' | 'outlined' | undefined;
  fullWidth?: boolean;
  loadingEnable?: boolean;
}): JSX.Element => {
  const formikContext = useFormikContext();
  const { isSubmitting: loading, validateForm, setTouched, submitForm } = formikContext;
  return (
    <LoadingButton
      loadingPosition="start"
      type="button"
      loading={loading || loadingEnable}
      variant={variant}
      disableRipple
      onClick={async (e) => {
        e.preventDefault();
        const errors = await validateForm();
        if (Object.keys(errors).length) {
          setTouched(setNestedObjectValues(errors, true), true);
          const firstErrorField = getFirstErrorField(errors);
          if (firstErrorField) {
            const firstInvalidElement = document.getElementsByName(firstErrorField)?.[0] as
              | HTMLElement
              | undefined;
            firstInvalidElement?.focus();
          }
          return;
        }
        submitForm();
      }}
      sx={{
        mt: 3,
        mb: 2,
        color: variant === 'contained' ? 'common.white' : 'primary.main',
        lineHeight: 1.5,
        fontSize: 14,
        '&:focus-visible': {
          outline: '2px solid #153760',
          outlineOffset: '2px',
        },
      }}
      fullWidth={fullWidth}
      {...props}>
      {label}
    </LoadingButton>
  );
  // return (
  //   <Button
  //     type="submit"
  //     fullWidth={fullWidth}
  //     variant={variant}
  //     sx={{ mt: 3, mb: 2, color: 'common.white', lineHeight: 1.5, fontSize: 14 }}
  //     disabled={disabled}
  //     {...props}>
  //     {l}
  //   </Button>
  // );
};
export default MFSubmitButton;
